import CommentPanelStyles from "./CommentPanel.module.scss";
import closeIcon from "../../assets/images/close.svg";
import downloadIcon from "../../assets/download_icon.svg";
import geminiIcon from "../../assets/gemini_logo.svg";
import Loader from "../Loader/Loader";
import CompletedTick from "../../assets/images/completedTick.svg";
import Button from "../Button/Button";
import { getSignedUrlForDoc } from "../../services/FileUpload.service";
import DownloadDoc from "../../assets/download.svg";
import { isEmpty } from "underscore";
import {
  downloadFileFromUrl,
  getTotalCommentsNumber,
} from "../../common/utils";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Accordian from "../Accordian/Accordian";
import { Checkbox } from "antd";
import Typography from "../Typography/Typography";
import ThumbUpSvg from "../../assets/Green_thumb_up.svg";
import ThumbDownSvg from "../../assets/Red_thumb_down.svg";
import { useSearchParams } from "react-router-dom";
const CommentCard = ({
  comment,
  handleMoveToComment,
  commentsWithId,
  handleMtcLoader,
  selectedTabs,
  googleDocMeta,
}: any) => {
  const [commentWithId, setCommentWithId] = useState<any>([]);
  // Local UI state for like/dislike per comment
  const [feedbackState, setFeedbackState] = useState<{
    liked?: boolean;
    disliked?: boolean;
  }>({});

  // Handlers extracted so they can be reused for click and keyboard events
  const toggleLike = (e?: React.SyntheticEvent) => {
    if (e) e.stopPropagation();
    setFeedbackState((prev) => ({
      liked: !prev.liked,
      // if we like, ensure disliked is false
      disliked: prev.liked ? prev.disliked : false,
    }));
  };

  const toggleDislike = (e?: React.SyntheticEvent) => {
    if (e) e.stopPropagation();
    setFeedbackState((prev) => ({
      disliked: !prev.disliked,
      // if we dislike, ensure liked is false
      liked: prev.disliked ? prev.liked : false,
    }));
  };
  
  const handleCommentClick = () => {
    let identifier;
    
    // For workbench document review (sourcing hub flow)
    if (googleDocMeta?.data || Array.isArray(googleDocMeta)) {
      console.log("=== CommentCard Click (Sourcing Hub Flow) ===");
      console.log("comment.original_comment:", comment.original_comment);
      console.log("googleDocMeta:", googleDocMeta);
      
      // Handle both possible response structures: { data: [...] } or [...]
      const metaData = Array.isArray(googleDocMeta) ? googleDocMeta : googleDocMeta?.data;
      
      if (metaData && Array.isArray(metaData)) {
        // Find matching comment by content
        const matchingMeta = metaData.find((meta: any) => 
          meta.content?.trim().toLowerCase() === comment.original_comment?.trim().toLowerCase()
        );
        
        if (matchingMeta?.comment_id) {
          console.log("✅ Found matching comment_id:", matchingMeta.comment_id);
          identifier = matchingMeta.comment_id;
        } else {
          console.warn("❌ No matching comment_id found. Falling back to content.");
          console.warn("Available meta comments:", metaData.map((m: any) => ({ content: m.content, comment_id: m.comment_id })));
          identifier = comment.original_comment; // Fallback
        }
      } else {
        console.warn("googleDocMeta is not an array, using comment content as fallback");
        identifier = comment.original_comment;
      }
    } else {
      // For regular contract review, use comment_id from commentsWithId
      console.log("=== CommentCard Click (Original Flow) ===");
      identifier = commentWithId?.[0]?.comment_id;
    }
    
    console.log("Final identifier to pass:", identifier);
    
    if (identifier) {
      handleMoveToComment(identifier);
      handleMtcLoader();
    }
  };
  
  useEffect(() => {
    if (commentsWithId) {
      const res = commentsWithId?.filter(
        (item: any) => item?.content === comment.original_comment
      );
      setCommentWithId(res);
    }
  }, [commentsWithId]);
  const isHighlighted = selectedTabs
    .map((tab: string) => tab?.toLowerCase())
    .includes(comment.severity?.toLowerCase());

  return (
    <>
      <div
        className={`${CommentPanelStyles.commentCard} ${
          isHighlighted
            ? CommentPanelStyles[`card-${comment.severity?.toLowerCase()}`]
            : ""
        }`}
        onClick={handleCommentClick}
      >
        {/* <div className={CommentPanelStyles.actionbuttons}></div> */}
        <div className={CommentPanelStyles.commentTitle}>
          {/* <h2>Comment</h2> */}
          <p>{comment?.original_comment}</p>
        </div>
      </div>
      {isHighlighted && (
        <div className={CommentPanelStyles.iconContainer}>
          <img
            src={ThumbUpSvg}
            alt="Thumb Up"
            role="button"
            tabIndex={0}
            aria-pressed={feedbackState.liked ? "true" : "false"}
            className={`${CommentPanelStyles.thumbUp} ${
              feedbackState.liked ? CommentPanelStyles.activeThumbUp : ""
            }`}
            onClick={(e) => toggleLike(e)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleLike();
              }
            }}
          />
          <img
            src={ThumbDownSvg}
            alt="Thumb Down"
            role="button"
            tabIndex={0}
            aria-pressed={feedbackState.disliked ? "true" : "false"}
            className={`${CommentPanelStyles.thumbDown} ${
              feedbackState.disliked ? CommentPanelStyles.activeThumbDown : ""
            }`}
            onClick={(e) => toggleDislike(e)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleDislike();
              }
            }}
          />
        </div>
      )}
    </>
  );
};

const CommentPanel = ({
  handleShowComments,
  comments,
  processingStage,
  handleStartReview,
  loading,
  fileName,
  suggestions,
  handleMoveToComment,
  commentsWithId,
  isContractReviewCompleted,
  handleMarkDocumentComplete,
  handleMtcLoader,
  fileId,
  docDetails,
  googleDocMeta,
  useSourcingHubFlow,
  handleValidateAgain,
}: any) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [searchParams] = useSearchParams();
  
  // Get tab parameter from URL
  const tabParam = searchParams.get('tab');
  const isReviewInProgress = tabParam === 'review_inprogress';
  const isReviewNotStarted = tabParam === 'review_not_started';
  const isReviewPending = tabParam === 'review_pending' || tabParam === 'review_pending_dashboard';
  const isReviewCompleted = tabParam === 'review_completed';
  // Determine if the Mark as Reviewed button should be enabled.
  // For sourcing flow, allow marking when review is in progress OR when review is not started (special case).
  // For original flow, allow marking when review is pending.
  const canMarkReviewed =
    isReviewInProgress || (!useSourcingHubFlow && isReviewPending) || (useSourcingHubFlow && isReviewNotStarted);
  
  // const [selectedTabs, setSelectedTabs] = useState<string[]>([]);
  const [selectedTabs, setSelectedTabs] = useState<string[]>([
    "High",
    "Medium",
    "Low",
  ]);
  const handleTabClick = (tab: string) => {
    setSelectedTabs((prevSelectedTabs) => {
      if (prevSelectedTabs.includes(tab)) {
        return prevSelectedTabs.filter((t) => t !== tab);
      } else {
        return [...prevSelectedTabs, tab];
      }
    });
  };
  const sortedComments = (comments: any) => {
    return comments?.sort((a: any, b: any) => a?.page_number - b?.page_number);
  };

  const [suggestionsToBeShown, setSuggestionsToBeShown] = useState<any>([]);

  useEffect(() => {
    if (suggestions && suggestionsToBeShown?.length === 0) {
      setSuggestionsToBeShown(
        Object.keys(suggestions)?.map((item) => suggestions?.[item]?.category)
      );
    }
  }, [suggestions]);

  const handleCloseCommnents = () => {
    handleShowComments(false);
  };

  const handleStartReviewClick = () => {
    handleStartReview();
  };

  const handleCheckBoxChange = (value: any) => {
    const temp = [...suggestionsToBeShown];
    const index = temp.indexOf(value);
    if (index === -1) {
      temp.push(value);
    } else {
      temp.splice(index, 1);
    }
    setSuggestionsToBeShown(temp);
  };

  const handleDownload = async () => {
    const docName = fileName + "_reviewed.docx";
    setIsDownloading(true);
    getSignedUrlForDoc({
      file_name: docName,
    })
      .then((signed_url) => {
        downloadFileFromUrl(signed_url, docName);
      })
      .catch(() => {
        toast.error("File could not be downloaded.", { position: "top-right" });
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  return (
    <div className={CommentPanelStyles.commentContainer}>
      <div
        className={`${CommentPanelStyles.commentWrapper} ${
          processingStage === 0
            ? CommentPanelStyles["bg-primary"]
            : CommentPanelStyles["bg-primary"]
        } `}
      >
        {processingStage === 0 ? (
          <>
            <div className={CommentPanelStyles.stageOne}>
              {/* <div className={CommentPanelStyles.header}>
                <div className={CommentPanelStyles.logo}>
                  <img src={logoNew} alt="" />
                </div>
              </div>
              <hr /> */}
              <div className={CommentPanelStyles.content}>
                {/* If sourcing flow is auto-starting (useSourcingHubFlow && not review_not_started),
                    show only a loader with 'Loading...' and a single 'Starting review' text.
                    Otherwise show the descriptive paragraph and Start Review button as before. */}
                {useSourcingHubFlow && !isReviewNotStarted ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Loader loaderText={"Generation of comments may take a while"} />
                  </div>
                ) : (
                  <>
                    <span>
                      Improve the quality of your document with VMO Assistant
                      comprehensive review, providing you with insightful comments.
                    </span>

                    {/* Show Start Review when tab explicitly indicates review_not_started OR when not using sourcing hub flow */}
                    {isReviewNotStarted || !useSourcingHubFlow ? (
                      <div
                        className={CommentPanelStyles.startReview}
                        onClick={handleStartReviewClick}
                      >
                        <span>Start Review</span>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </>
        ) : loading ? (
          <Loader loaderText={"Generation of comments may take a while"} />
        ) : (
          <>
            <div className={CommentPanelStyles.headingContent}>
              <div className={CommentPanelStyles.content}>
                <div style={{ display: "flex", gap: "4px" }}>
                  <img src={geminiIcon} alt="Orbit Icon" />
                  <h2>
                    Suggestions {"("}
                    {getTotalCommentsNumber(comments)}
                    {")"}
                  </h2>
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <span>{getTotalCommentsNumber(comments)} comments</span>
                </div> */}
              </div>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                {" "}
                {/* <button disabled={true} className={CommentPanelStyles.rerun}>
                  <img src={Rerun} alt="" />
                  <span>Rerun</span>
                </button> */}
                <div
                  className={CommentPanelStyles.closeIcon}
                  onClick={handleDownload}
                >
                  <img src={downloadIcon} alt="" />
                </div>
                <div
                  className={CommentPanelStyles.closeIcon}
                  onClick={handleCloseCommnents}
                >
                  <img src={closeIcon} alt="" />
                </div>
              </div>
            </div>
            <div className={CommentPanelStyles.tabsContainer}>
              {["High", "Medium", "Low"].map((tab) => (
                <span
                  key={tab}
                  className={`${CommentPanelStyles.tab} ${
                    selectedTabs.includes(tab)
                      ? CommentPanelStyles[`selected-${tab?.toLowerCase()}`]
                      : ""
                  }`}
                  onClick={() => handleTabClick(tab)}
                >
                  {selectedTabs.includes(tab)
                    ? `${
                        docDetails[`count_of_${tab?.toLowerCase()}_severity`]
                      } ${tab}`
                    : tab}
                </span>
              ))}
            </div>
            <hr />
            <div className={CommentPanelStyles.commentList}>
              {!isEmpty(comments) && suggestions && (
                <>
                  {/* <div className={CommentPanelStyles.suggestions}>
                    <h2>Recommendations</h2>

                    <div className={CommentPanelStyles.recommendedItems}>
                      {suggestions?.map((item: any) => {
                        return (
                          <div>
                            <span className={CommentPanelStyles.category}>
                              <Checkbox
                                type="checkbox"
                                defaultChecked
                                value={item?.category}
                                className={
                                  CommentPanelStyles.suggestionCheckBox
                                }
                                onChange={(e) =>
                                  handleCheckBoxChange(e?.target?.value)
                                }
                              />
                              {item?.category}
                            </span>{" "}
                            <span> {item?.count}</span>{" "}
                          </div>
                        );
                      })}
                    </div>
                  </div> */}
                </>
              )}

              {isEmpty(comments) && (
                <div
                  style={{
                    margin: "40px 0 20px 0",
                    background: "white",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <p style={{ textAlign: "left" }}>
                    No recommendations were given for this document. Looks like
                    your document may already be optimized, or please check the
                    document as the content might be outside the scope.
                  </p>
                </div>
              )}
              <div className={CommentPanelStyles.suggestionsList}>
                {suggestionsToBeShown &&
                  Object?.keys(comments)
                    ?.filter((key) => {
                      return suggestionsToBeShown?.includes(key);
                    })
                    ?.map((key) => {
                      return (
                        <>
                          <Accordian
                            defaultOpen={false}
                            theme={"comments"}
                            title={key}
                            key={key}
                          >
                            <>
                              {sortedComments(comments[key])?.map(
                                (comment: any, commentIndex: number) => (
                                  <CommentCard
                                    handleMtcLoader={handleMtcLoader}
                                    key={comment.original_comment}
                                    commentsWithId={commentsWithId}
                                    comment={comment}
                                    handleMoveToComment={handleMoveToComment}
                                    selectedTabs={selectedTabs}
                                    googleDocMeta={googleDocMeta}
                                  />
                                )
                              )}
                            </>
                          </Accordian>
                        </>
                      );
                    })}
              </div>
            </div>
            {comments && !loading && processingStage !== 0 && (
              <div className={CommentPanelStyles.actionButtons}>
                {/* Validate Again button - only for sourcing flow and when tab is review_inprogress or review_not_started */}
                {useSourcingHubFlow && (isReviewInProgress || isReviewNotStarted) && (
                  <Button
                    onClick={() => {
                      // Re-run validation / start review flow again (sourcing flow only)
                      if ((window as any)?.handleValidateAgain) {
                        // backward compatibility if injected globally
                        (window as any).handleValidateAgain();
                      }
                      if (typeof handleValidateAgain === 'function') {
                        handleValidateAgain();
                      } else if (handleStartReview) {
                        // fallback to starting review if validate handler not provided
                        handleStartReview();
                      }
                    }}
                    variant="outlined"
                    style={{
                      borderRadius: "32px",
                      padding: "6px 16px",
                      fontSize: "12px",
                      marginBottom: "8px",
                    }}
                  >
                    <Typography style={{ padding: "4px 0px" }}>
                      Validate Again
                    </Typography>
                  </Button>
                )}

                <Button
                  disabled={!canMarkReviewed}
                  onClick={() => {
                    // Only proceed when allowed for the current flow/tab
                    if (canMarkReviewed) {
                      handleMarkDocumentComplete(fileId);
                    }
                  }}
                  startIcon={
                    <img
                      src={CompletedTick}
                      style={{ marginRight: "4px" }}
                      alt=""
                    />
                  }
                  style={{ 
                    borderRadius: "32px",
                    opacity: canMarkReviewed ? 1 : 0.5,
                    cursor: canMarkReviewed ? "pointer" : "not-allowed",
                    backgroundColor: isReviewCompleted ? "#9e9e9e" : undefined,
                  }}
                >
                  <Typography style={{ padding: "4px 0px" }}>
                    {isReviewCompleted
                      ? "Marked Completed"
                      : (isReviewInProgress || (useSourcingHubFlow && isReviewNotStarted))
                      ? "Mark as Completed"
                      : !useSourcingHubFlow && isReviewPending
                      ? "Mark as Completed"
                      : "Review Completed"}
                  </Typography>
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CommentPanel;
